export const STORAGE_KEY = "recentSharedEmails";
const EXPIRATION_DAYS = 3;
const EXPIRATION_TIME = EXPIRATION_DAYS * 24 * 60 * 60 * 1000;

export const setSharedEmails = () => {
  const initState = [
    { name: "Ethan Carter", timestamp: Date.now(), email: "ethan@rhombuz.io" },
    {
      name: "Olivia Bannet",
      timestamp: Date.now(),
      email: "olivia@rhombuz.io",
    },
    {
      name: "Jacob Reynolds",
      timestamp: Date.now(),
      email: "jacob@rhombuz.io",
    },
  ];
  localStorage.setItem(STORAGE_KEY, JSON.stringify(initState));
};

export const getSharedEmails = () => {
  const storedData = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
  const now = Date.now();

  const validData = storedData.filter(
    (item) => now - item.timestamp < EXPIRATION_TIME,
  );

  localStorage.setItem(STORAGE_KEY, JSON.stringify(validData));

  return validData.map(({ name, email }) => ({ name, email }));
};
export const addNewEmail = (email) => {
  const now = Date.now();
  let name = extractNameFromEmail(email);
  let storedData = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];

  const existingIndex = storedData.findIndex((item) => item.email === email);
  if (existingIndex !== -1) {
    storedData[existingIndex].timestamp = now;
  } else {
    storedData.push({ name, email, timestamp: now });
  }

  localStorage.setItem(STORAGE_KEY, JSON.stringify(storedData));
  return storedData.map(({ name, email }) => ({ name, email }));
};

const extractNameFromEmail = (email) => {
  if (!email.includes("@")) return "";

  const username = email.split("@")[0];

  return username
    .replace(/[._\d]/g, " ")
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

window.onload = () => {
  const storedData = JSON.parse(localStorage.getItem("recentSharedEmails"));

  if (!storedData || storedData.length === 0) {
    setSharedEmails();
  }
};